import { CircleCheckBig } from "lucide-react";
import { useTranslation } from "react-i18next";

type OcrModalResponseScreenProps = {
  navigateToPendingShipmentsManualPage: () => void;
};

export const OcrModalResponseScreen = ({
  navigateToPendingShipmentsManualPage,
}: OcrModalResponseScreenProps) => {
  const { t } = useTranslation("boExpeditions");
  navigateToPendingShipmentsManualPage();
  return (
    <dialog className="fixed top-0 left-0 z-50 flex h-full w-full items-center justify-center overflow-auto bg-[#00000080] backdrop-blur-sm">
      <div className="m-auto max-w-[90vw] min-w-[300px] rounded-lg bg-white lg:max-w-[1000px]">
        <div className="items- relative flex flex-col items-center justify-center gap-4 p-6">
          <CircleCheckBig className="h-20 w-20" color="green" />
          <h3 className="flex flex-row items-end gap-1">
            <span className="flex h-fit flex-row items-end gap-1 text-center align-baseline text-xl font-semibold text-black">
              {t("pendingShipmentsOcrModal.processedTitle")}
            </span>
          </h3>
        </div>
      </div>
    </dialog>
  );
};
